// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd05acf8","255":"e9bfc74e","481":"4bf05836","634":"3dfd9042","654":"b41fa2f4"}[chunkId] + ".chunk.js";
};